export default "__VITE_ASSET__DO_Zu9Uf__"